import type {ShareableType} from './resource-name';

export interface BdServiceBusResource {
  resourceId: string;
  resourceType: ShareableType;
  eventType: 'CREATED' | 'DELETED' | 'UPDATED';
}

export function isServiceBusResource(obj: any): obj is BdServiceBusResource {
  return obj && obj.resourceId && obj.resourceType && obj.eventType;
}
